import * as i0 from "@angular/core";
var GlobalsPermissions = /** @class */ (function () {
    function GlobalsPermissions() {
        this.FUTURE = 'FuturePermissions';
        this.BASE = 'BaseSystem';
        this.MANAGE_USERS = 'ManageUsers';
        this.MANAGE_PROJECTS = 'ManageProjects';
        this.MANAGE_TEMPLATES = 'ManageTemplates';
        this.MANAGE_CONTRACTS_NO_VALUES = 'ManageContractsNoValues';
        this.MANAGE_CONTRACTS_VALUES = 'ManageContractsValues';
        this.COMPLETE_DAY = 'CompleteDay';
        this.BILLING = 'Billing';
        this.MANAGE_READERS = 'ManageReaders';
        this.SAFE_PROX_REPORT = 'CanViewContactTracingInfo';
    }
    GlobalsPermissions.ngInjectableDef = i0.defineInjectable({ factory: function GlobalsPermissions_Factory() { return new GlobalsPermissions(); }, token: GlobalsPermissions, providedIn: "root" });
    return GlobalsPermissions;
}());
export { GlobalsPermissions };
